module.exports = __webpack_public_path__ + "img/42_6.66e94008.png";